import Vue from "vue";
function newCode() {
    Vue.prototype.$bus.$emit("to-show-qrcode")
}
export default newCode